/* eslint-disable import/prefer-default-export */
import React from 'react';
import { FlexAround } from '../../style/styled';

type TProps = {
  image: string;
  text: string;
  centered?: boolean; // centered by vertical
  width?: string;
};

export function ImgBox({
  image, text, centered, width,
}: TProps) {
  return (
    <FlexAround h={centered ? '100%' : 'auto'} w="auto" d="column" bc="none">
      <img src={image} alt={text} width={width} />
    </FlexAround>
  );
}

ImgBox.defaultProps = {
  centered: false,
  width: 'auto',
};
